import useStore from "../../store/store";
import styles from '../../style.module.scss'
import Hint from "../ui/hint/hint";
const SummaryHead = () => {
    const summaryHead = useStore((state) => state.summaryHead)
    const lang = useStore((state) => state.lang)

    const t = {
        enterToAccount: lang === 'en' ? 'Log in to your account to see your status' : 'Войдите в аккаунт, чтобы видеть статус',
        yourStatus: lang === 'en' ? 'Your status' : 'Ваш статус'
    };

    if (!!summaryHead) {
        if (!!summaryHead?.needAuth){
            const authMessage = lang === 'en'
                ? (summaryHead.message_en || summaryHead.message || t.enterToAccount)
                : (summaryHead.message || t.enterToAccount);
            return (
                <a href={'/cp/'} className={`${styles.needAuth} p-small-size`} target={'_blank'} rel={'noreferrer'}>
                    {authMessage}
                </a>
            );
        } else {
            return (
                <div className={`${styles.head} status-head-${summaryHead?.cardStatus}`}>
                    <div className={styles.label}>{t.yourStatus}</div>
                    <div className={styles.status}>
                        {summaryHead.cardName}
                        {
                            !!summaryHead?.cardText && (<Hint text={summaryHead.cardText} fill={'#fff'}/>)
                        }
                    </div>
                </div>
            );
        }
    }
    return null;
};

export default SummaryHead;